import { Button } from '@mui/material'
import React, { useState } from 'react'
import ConfirmModal from '../confirmModal';
import ViewUserModal from './viewUserModal';

const UserCard = ({ user, userUpdate, userDelete }) => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

    function parseDMYtoDate(str) {
        const [d, m, y] = str.split('/');
        return new Date(y, m - 1, d, 23, 59, 59, 999);
    }

    // Verifica si está expirado
    const fechaExpiracion = parseDMYtoDate(user.expirationDate);
    const isExpired = fechaExpiracion < new Date();
    const status = isExpired && user.status !== 'suspendido' ? 'inactivo' : user.status;
    const statusColor = ((isExpired && user.status !== 'suspendido' ) || status === 'inactivo') ? 'var(--color-danger)' : status === 'activo' ? 'var(--color-success)' : 'var(--color-warning)';

    return (
        <div className='user-card'>
            <h3 className='user-name'>{user.name}</h3>
            <p className='user-email'><strong>Email:</strong> {user.email}</p>
            <p className='user-status' style={{ color: statusColor }}>
                <strong>Estatus:</strong> {status}
            </p>
            <p className='user-expiration'><strong>Expira:</strong> <span style={{ color: isExpired ? 'var(--color-danger)' : '' }}>{user.expirationDate}</span></p>
            <div className='user-buttons_container'>
                <Button variant='contained' sx={{ backgroundColor: 'var(--color-primary)' }} onClick={() => setIsEditModalOpen(true)}>
                    <span className="material-symbols-rounded">visibility</span>
                </Button>
                <Button variant='contained' sx={{ backgroundColor: 'var(--color-danger)' }} onClick={() => setIsConfirmModalOpen(true)}>
                    <span className="material-symbols-rounded">delete_forever</span>
                </Button>
            </div>
            {isEditModalOpen &&
                <ViewUserModal isOpen={isEditModalOpen} onClose={setIsEditModalOpen} user={user} confirmFunction={(newData) => {
                    userUpdate(newData, true);
                    setIsEditModalOpen(false);
                }} />
            }
            {isConfirmModalOpen &&
                <ConfirmModal title={'Confirmación'} text={'¿Está seguro de eliminar permanentemente este usuario?'} isOpen={isConfirmModalOpen} onClose={setIsConfirmModalOpen}
                    confirmFunction={() => {
                        userDelete({ userId: user.userId }, true);
                        setIsConfirmModalOpen(false);
                    }} />
            }
        </div>
    )
}

export default UserCard;
